import CLPViewState from '../store/schema/CLPViewState';
import getDefaultCLPLabel from './getDefaultCLPLabel';

const STANDARD_LABEL_METHOD = 'Standard';
const PRIVILEGED_LABEL_METHOD = 'Privileged';

export default function(clpViewState: CLPViewState): string {
    let clpLabelMethod = STANDARD_LABEL_METHOD;
    let { selectedCLPLabel, originalCLPLabel } = clpViewState;
    if (selectedCLPLabel) {
        if (originalCLPLabel) {
            if (selectedCLPLabel.id != originalCLPLabel.id) {
                clpLabelMethod = PRIVILEGED_LABEL_METHOD;
            }
        } else {
            // If the tenant does not set default label
            // getDefaultCLPLabel would return null
            const defaultLabel = getDefaultCLPLabel();
            if (!defaultLabel || selectedCLPLabel.id != defaultLabel.id) {
                clpLabelMethod = PRIVILEGED_LABEL_METHOD;
            }
        }
    }
    return clpLabelMethod;
}
